






























import { defineComponent, reactive } from "@vue/composition-api";

export default defineComponent({
    name: "ConfirmDialog",
    props: {
        message: { type: String, default: "" },
        title: { type: String, default: "Confirm" },
        options: { type: Object, default: null },
        value: { type: Boolean, default: false }
    },
    setup(props, context) {
        const option = reactive({
            color: "grey lighten-3",
            width: 400,
            zIndex: 200,
            noconfirm: false
        });
        if (props.options) {
            const opt = props.options;
            if (opt.color) {
                option.color = opt.color;
            }
            if (opt.width) {
                option.width = opt.width;
            }
            if (opt.zIndex) {
                option.zIndex = opt.zIndex;
            }
            if (opt.noconfirm) {
                option.noconfirm = opt.noconfirm;
            }
        }
        const agree = () => {
            context.emit("input", false);
            context.emit("OnOk");
        };
        const cancel = () => {
            context.emit("input", false);
            context.emit("OnCancel");
        };
        return {
            agree,
            cancel,
            option
        };
    }
});
